var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "orderinfo userbox",
      attrs: { id: "orderinfo" }
    },
    [
      _c("div", { staticClass: "userTitle" }, [
        _vm._v(_vm._s(_vm.$t("Points")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pointTab" }, [
        _c(
          "div",
          {
            class: _vm.pointTab == "" ? "on" : "",
            on: {
              click: function($event) {
                return _vm.setTab("")
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("PointsRedemption")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: _vm.pointTab == 1 ? "on" : "",
            on: {
              click: function($event) {
                return _vm.setTab(1)
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("PointsHistory")))]
        )
      ]),
      _vm._v(" "),
      _vm.pointTab == ""
        ? _c(
            "div",
            { staticClass: "pointChange" },
            [
              _c("img", {
                staticClass: "pointLogo",
                attrs: {
                  src: require("../../../static/images/icon/loading.svg")
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "nowPoint" }, [
                _vm._v(
                  _vm._s(_vm.$t("MyPoints")) +
                    ": " +
                    _vm._s(_vm.userInfo.PointsAll)
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: { model: _vm.ruleForm, rules: _vm.rules }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "login_form_item",
                      attrs: { prop: "ExchangeCode" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "login_ipt",
                        attrs: { placeholder: _vm.$t("verify.RedemptionCode") },
                        on: {
                          input: function($event) {
                            return _vm.setInput()
                          }
                        },
                        model: {
                          value: _vm.ruleForm.ExchangeCode,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "ExchangeCode", $$v)
                          },
                          expression: "ruleForm.ExchangeCode"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "exchange_btn",
                      attrs: { disabled: _vm.disabled, type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("ruleForm")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("ConfirmRedemption")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.pointTab == 1
        ? _c(
            "div",
            [
              !_vm.isNull && _vm.list != ""
                ? _c(
                    "div",
                    [
                      _c("div", { staticClass: "nowPoint" }, [
                        _vm._v(
                          _vm._s(_vm.$t("MyPoints")) +
                            ": " +
                            _vm._s(_vm.userInfo.PointsAll)
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pointChangelist" }, [
                        _c("span", { staticClass: "pointName" }, [
                          _vm._v(_vm._s(_vm.$t("Title")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "pointTime" }, [
                          _vm._v(_vm._s(_vm.$t("Date")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "pointType" }, [
                          _vm._v(_vm._s(_vm.$t("Type")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "pointPoint" }, [
                          _vm._v(_vm._s(_vm.$t("Points")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        _vm._l(_vm.list, function(item, index) {
                          return _c(
                            "div",
                            { key: index },
                            [
                              item.OrderId != null
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "pointChangelist",
                                      attrs: {
                                        to: {
                                          path: "/order/detail/" + item.OrderId
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "pointName line_txt1" },
                                        [_vm._v(_vm._s(item.ExchangeCode))]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "pointTime" }, [
                                        _vm._v(_vm._s(item.CreateDate))
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "pointType" }, [
                                        _vm._v(
                                          _vm._s(
                                            item.Status > 1
                                              ? _vm.$t("Spent")
                                              : _vm.$t("Earned")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "pointPoint" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.Status > 1
                                                ? "-" + item.Score
                                                : "+" + item.Score
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "pointChangelist" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "pointName line_txt1" },
                                        [_vm._v(_vm._s(item.ExchangeCode))]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "pointTime" }, [
                                        _vm._v(_vm._s(item.CreateDate))
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "pointType" }, [
                                        _vm._v(
                                          _vm._s(
                                            item.Status > 1
                                              ? _vm.$t("Spent")
                                              : _vm.$t("Earned")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "pointPoint" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.Status > 1
                                                ? "-" + item.Score
                                                : "+" + item.Score
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("pagination", {
                        attrs: { TotalCount: _vm.TotalCount, ps: _vm.ps },
                        on: { ps: _vm.pageSize, pi: _vm.pageIndex }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isNull
                ? _c("nonull", {
                    attrs: { type: "order", text: _vm.$t("Norecords") }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d2a35d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2a35d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/point.vue
// module id = null
// module chunks = 